import { create } from "zustand";
import type { NoticeFilterId } from "./notice-conversations";

interface NoticeSidebarState {
  collapsed: boolean;
  activeFilter: NoticeFilterId;
  searchQuery: string;
  toggleCollapsed: () => void;
  setCollapsed: (collapsed: boolean) => void;
  setActiveFilter: (filter: NoticeFilterId) => void;
  setSearchQuery: (query: string) => void;
}

export const useNoticeSidebar = create<NoticeSidebarState>((set) => ({
  collapsed: false,
  activeFilter: "all",
  searchQuery: "",
  toggleCollapsed: () =>
    set((state) => ({
      collapsed: !state.collapsed,
      searchQuery: state.collapsed ? state.searchQuery : "",
    })),
  // Collapsing hides the search box, so clear the query too.
  setCollapsed: (collapsed) =>
    set(collapsed ? { collapsed, searchQuery: "" } : { collapsed }),
  setActiveFilter: (filter) => set({ activeFilter: filter }),
  setSearchQuery: (query) => set({ searchQuery: query }),
}));
